import React from 'react'
import ReactDOM from 'react-dom'
import CookiePolicy from '../../../site/layout/component/CookiePolicy'
import ThemeContext from '../../../site/layout/component/Theme/ThemeContext'

const debug = require('debug')('cookiePolicy')

export default () => {
  debug('init')
  document.addEventListener('DOMContentLoaded', () => {
    const theme = document.querySelector('body').dataset.theme

    document.querySelectorAll('.js-cookie-policy').forEach(appNode => {
      const props = JSON.parse(appNode.getAttribute('data-props') || '{}')
      ReactDOM.render(
        <ThemeContext.Provider value={theme}>
          <CookiePolicy {...props} />
        </ThemeContext.Provider>,
        appNode
      )
    })
  })
}
